export default "__VITE_ASSET__D0yVR7Wc__"